import React, { useState, useEffect } from 'react'
// import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Components
import DesktopContent from './components/DesktopContent'
import MobileContent from './components/MobileContent'

// Lib MISC

import styles from './style.scss'
import words from "@/assets/worddict.json"

const cx = classnames.bind(styles)

export const propTypes = {}

const MAX_MOBILE_WIDTH = 767

function Feature ({ lang }) {
  const [isMoblieLayout, setIsMoblieLayout] = useState(false)
  const $t = words[lang]

  useEffect(() => {
    const handleWindowWidth = () => {
      if (window.innerWidth <= MAX_MOBILE_WIDTH) {
        setIsMoblieLayout(true)
      } else {
        setIsMoblieLayout(false)
      }
    }

    handleWindowWidth()

    window.addEventListener('resize', handleWindowWidth)

    return () => {
      window.removeEventListener('resize', handleWindowWidth)
    }
  }, [setIsMoblieLayout])

  return (
    <div className={cx('feature')}>
      <div className={cx('feature-wrapper')}>
        <div className={cx('feature-wrapper__info')}>
          <p className={cx('feature-wrapper__info-type')}>{$t.TXT_Feature_title}</p>
          <p className={cx('feature-wrapper__info-title')}>{$t.TXT_Feature_subtitle}</p>
        </div>
        {/* 因為 desktop 跟 mobile 的 layout 跟動畫差太多，所以直接拆成兩個 component  */}
        {!isMoblieLayout && <DesktopContent lang={lang} />}
        {isMoblieLayout && <MobileContent lang={lang} />}
      </div>
    </div>
  )
}

Feature.propTypes = propTypes

export default Feature
